import Vue from 'vue'

Vue.filter('filterDate', (value, fmt) => {
  if (!value) return '-'

  const date = new Date(value)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1),
    'd+': date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
    'h+': date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
    'm+': date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
    's+': date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : str);
    }
  }
  return fmt
})

Vue.filter('getWeek', (value) => {
  if (!value) return '-'
  const date = new Date(value)
  const num = date.getDay()
  let week = '星期'
  switch (num) {
    case 0:
      week += '日'
      break;
    case 1:
      week += '一'
      break;
    case 2:
      week += '二'
      break;
    case 3:
      week += '三'
      break;
    case 4:
      week += '四'
      break;
    case 5:
      week += '五'
      break;
    case 6:
      week += '六'
      break;
    default:
      break;
  }
  return week
})

Vue.filter('costTime', (value) => {
  if (!value) return '-'
  const time = Math.floor(value / 1000)
  const day = Math.floor(time / (3600 * 24))
  const hour = Math.floor((time - day * 3600 * 24) / 3600)
  const minute = Math.floor((time - day * 3600 * 24 - hour * 3600) / 60)
  const second = Math.floor(time - day * 3600 * 24 - hour * 3600 - minute * 60)
  let str = ''
  if (day > 0) {
    str += day + '天'
  }
  if (hour > 0) {
    str += hour + '时'
  }
  if (minute > 0) {
    str += minute + '分'
  }
  str += second + '秒'
  return str
})

// 将global中的数组转换成filter过滤器渲染
Vue.filter('global', (value, arr) => {
  for (const item of arr) {
    if (item.value == value) {
      return item.label
    }
  }
  return ''
})

// 获取一段0-1，a-z，A-Z的随机数
Vue.filter('roll', (max, tabStr, tabNum) => {
  // max: 长度, tabStr: 间隔符, tabNum: 间隔值（每隔几个该值的字符插入一个间隔符）
  const rollArr = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "r",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];
  let str = "",
    tab = 0;
  for (let i = 0; i < max; i++) {
    const key = parseInt(Math.random() * (rollArr.length), 10);
    str += rollArr[key];
    tab++;
    if (tabStr && tab == tabNum) {
      str += "-";
      tab = 0;
    }
  }
  if (tabStr && tabNum) {
    str = str.substring(0, str.length - 1);
  }
  return str;
})